
import { h } from 'preact'
import { connectRefinementList } from 'react-instantsearch-dom'
import Count from './ResultsCount'
import Checkbox from '../../create-article/Checkbox'
import Phrase from '../../../libs/translationsUtils/phrase'

type contentType = 'ideation' | 'discussion' | 'question' | 'article'

type Hit = {
  label: contentType,
  value: string,
  count:number,
  isRefined: boolean
}

interface Props {
  items: Array<Hit>,
  title: string
  isFromSearch: boolean,
  refine: (val: string) => void,
  searchForItems: (val: string) => void,
  createURL: (val: string) => string
}

const labelMapping = {
  'ideation': <Phrase m='Forum' p='topic.form.type.idea.label' />,
  'discussion': <Phrase m='Forum' p='topic.form.type.discussion.label' />,
  'article': <Phrase m='Forum' p='advanced.search.filter.article' />,
  'question': <Phrase m='Forum' p='topic.form.type.question.label' />
}

const TopicTypesList = ({
  title,
  items,
  refine
}: Props) => {
  return (
    <div className='instant-search__topic-type-filter'>
      <h4>{ title }</h4>
      {!items.length ?
        <div class='instant-search__filter-no-results'><Phrase p='No results' m='Control' /></div>
      :
        <ul>
        {items.map(item => (
          <li key={item.label} className='instant-search__filter-list-item'>
            <div className={`instant-search-filter__label-wrapper ${item.isRefined ? 'refined' : ''}`}>
              <Checkbox
                label={labelMapping[item.label]}
                onUpdate={() => refine(item.value)}
                qaClasses={'topic-type-checkbox'}
                checked={item.isRefined}
              />
              <Count count={item.count} />
            </div>
          </li>
        ))}
        </ul>
      }
    </div>
  )
}

export default connectRefinementList(TopicTypesList)
